'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.slice')
require('core-js/modules/es.function.name')
require('core-js/modules/es.object.assign')
require('core-js/modules/es.object.keys')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _assertThisInitialized2 = _interopRequireDefault(
  require('@babel/runtime/helpers/assertThisInitialized')
)
var _inheritsLoose2 = _interopRequireDefault(require('@babel/runtime/helpers/inheritsLoose'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _EventEmitter2 = _interopRequireDefault(require('../EventEmitter'))
var _prepareRequestBody = _interopRequireDefault(require('../prepareRequestBody'))
var _num = require('../num')
var _obj = require('../obj')
var _is = require('../is')
var _Xhr = require('../Xhr')
var _json = require('../json')

var CHUNK_SIZE = 524288
var HEADERS = {
  // 'Content-Type': 'multipart/form-data'
}
var FileUploader = /*#__PURE__*/ (function(_EventEmitter) {
  ;(0, _inheritsLoose2.default)(FileUploader, _EventEmitter)

  function FileUploader(args) {
    var _this
    _this = _EventEmitter.call(this) || this
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), 'xhr', null)
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), '_sliceFrom', 0)
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), '_fileId', null)
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), 'attrs', void 0)
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), 'opts', void 0)
    ;(0, _defineProperty2.default)(
      (0, _assertThisInitialized2.default)(_this),
      'onChunkLoad',

      function(ev) {
        var trg = ev.target
        if (!(0, _Xhr.isXhr)(trg)) return
        if (trg.status < 200 || trg.status > 300) {
          _this.onChunkLoadError(ev)
          return
        }

        var resp = (0, _json.parseObj)(trg.responseText)

        if (_this._sliceFrom === _this.attrs.size) {
          _this.onUploadEnd(resp)
          return
        }

        if (resp !== null) {
          _this._fileId = (0, _is.isNum)(resp.file_id) ? resp.file_id : null
        }

        _this.emit('upload:progress', {
          ev: ev,
          uploaded: _this._sliceFrom,
          fileAttrs: _this.attrs,
          resp: resp
        })

        _this.uploadChunk()
      }
    )
    ;(0, _defineProperty2.default)(
      (0, _assertThisInitialized2.default)(_this),
      'onChunkLoadError',

      function(ev) {
        var trg = ev.target
        if (!(0, _Xhr.isXhr)(trg)) return

        _this.emit('upload:error', {
          ev: ev,
          fileAttrs: _this.attrs,
          resp: (0, _json.parseObj)(trg.responseText)
        })
      }
    )
    _this.attrs = FileUploader.getAttrsFromFile(args.file)
    _this.opts = FileUploader.getOptsFromFile(args)
    return _this
  }
  var _proto = FileUploader.prototype
  _proto.getChunk = function getChunk() {
    var start = this._sliceFrom
    var _this$attrs = this.attrs,
      size = _this$attrs.size,
      file = _this$attrs.file,
      type = _this$attrs.type
    var end = start + CHUNK_SIZE
    end = end > size ? size : end
    var chunk = file.slice(start, end, type)
    this._sliceFrom = end
    return chunk
  }
  _proto.getBody = function getBody() {
    var _this$attrs2 = this.attrs,
      name = _this$attrs2.name,
      size = _this$attrs2.size
    var body = Object.assign({ name: name, size: size, chunk: this.getChunk() }, this.opts.params)
    if (this._fileId !== null) {
      body.file_id = this._fileId
    }
    var fd = (0, _prepareRequestBody.default)({ body: body, as: 'formData' })
    return fd instanceof FormData ? fd : new FormData()
  }
  FileUploader.getAttrsFromFile = function getAttrsFromFile(file) {
    var name = file.name,
      type = file.type,
      size = file.size
    return { file: file, name: name, type: type, size: size }
  }
  FileUploader.getOptsFromFile = function getOptsFromFile(args) {
    var targetUrl = args.targetUrl,
      headers = args.headers,
      params = args.params,
      chunkSize = args.chunkSize
    return {
      targetUrl: targetUrl,
      headers: (0, _obj.castObj)(headers),
      params: (0, _obj.castObj)(params),
      chunkSize: (0, _num.castNum)(chunkSize, CHUNK_SIZE)
    }
  }
  _proto.uploadChunk = function uploadChunk() {
    this.destroyXhr()
    var targetUrl = this.opts.targetUrl
    var xhr = new XMLHttpRequest()
    xhr.open('POST', targetUrl)
    this.setXhrHeaders(xhr)
    xhr.onload = this.onChunkLoad
    xhr.onerror = this.onChunkLoadError
    xhr.send(this.getBody())
    this.xhr = xhr
  }
  _proto.onUploadEnd = function onUploadEnd(resp) {
    this.emit('upload:end', {
      fileAttrs: this.attrs,
      resp: resp
    })
  }
  _proto.setXhrHeaders = function setXhrHeaders(xhr) {
    var headers = Object.assign({}, HEADERS, this.opts.headers)

    Object.keys(headers).forEach(function(key) {
      xhr.setRequestHeader(key, headers[key])
    })
  }
  _proto.destroyXhr = function destroyXhr() {
    if (this.xhr === null) return
    this.xhr.onload = function() {}
    this.xhr.onerror = function() {}
    this.xhr.abort()
    this.xhr = null
  }
  _proto.destroy = function destroy() {
    this.destroyXhr()
    this.off()
    delete this.attrs.file
    delete this.opts
  }
  return FileUploader
})(_EventEmitter2.default)
var _default = FileUploader
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/FileUploader/index.js
// module id = 615
// module chunks = 0